import { cancelFrame, frame, time } from "motion-dom";
import { secondsToMilliseconds } from "motion-utils";
/**
 * Timeout defined in ms
 */
export function delay(callback, timeout) {
    const start = time.now();
    const checkElapsed = ({ timestamp }) => {
        const elapsed = timestamp - start;
        if (elapsed >= timeout) {
            cancelFrame(checkElapsed);
            callback(elapsed - timeout);
        }
    };
    frame.setup(checkElapsed, true);
    return () => cancelFrame(checkElapsed);
}
export function delayInSeconds(callback, timeout) {
    return delay(callback, secondsToMilliseconds(timeout));
}
//# sourceMappingURL=delay.js.map